import { inject } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivateChildFn,
	CanActivateFn,
	RouterState,
	RouterStateSnapshot,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { CORE_ROUTE, CustomerManagementSelector, RequiredActions } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { switchMap, take } from "rxjs/operators";

export const canActivate: CanActivateFn = (_route: ActivatedRouteSnapshot) => {
	const store = inject(Store<RouterState>);

	return store.select(CustomerManagementSelector.getCustomer).pipe(
		take(1),
		switchMap((customer) => {
			if (customer?.requiredActions.find((action) => action.actionType === RequiredActions.DocumentUpload)) {
				return Promise.resolve(true);
			}
			store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
			return Promise.resolve(false);
		})
	);
};

export const docVerificationRequiredGuard: CanActivateChildFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => canActivate(route, state);
